import { withStyles } from '@material-ui/core';
import ReceiptGiftCardField from './ReceiptGiftCardField';
import styles from './ReceiptGiftCardField.styles';

export default withStyles(styles)(ReceiptGiftCardField);
